import consumer from "./consumer"

consumer.subscriptions.create("RepartitionKeysChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    const row = document.getElementById(`repartition-key-${data.agreement}-${data.month}`)
    if (row) {
      row.outerHTML = data.html
    }
  }
});
